import { z } from "zod";

export const ModerateMintTx$Params = z.object({
  // CBOR Hex
  // Technically we only need to moderate and sign on the tx body
  tx: z.string(),
});
export type ModerateMintTx$Params = z.infer<typeof ModerateMintTx$Params>;

export const ModerateMintTx$Result = z.object({
  signature: z.string(), // CBOR Hex
});
export type ModerateMintTx$Result = z.infer<typeof ModerateMintTx$Result>;
